import { convertTimestampToMilliseconds, timezoneMoment } from 'common/util/time';

export const timestampToDate = (time: number, timezone: string | null): string => 
  timezoneMoment(timezone)(convertTimestampToMilliseconds(time)).format('MM/DD/YYYY');
